import React from 'react';
import {
	Tooltip,
	IconButton,
	Typography,
	Box,
} from '@barracuda-internal/bds-core-v2';
import Download from '@mui/icons-material/Download';
import Refresh from '@mui/icons-material/Refresh';
import { RemediateDropdown } from './RemediateDropdown';

interface TopBarActionsProps {
	isLoading: boolean;
	onDownload: () => void;
	onRefresh: () => void;
	tab: number;
	selectedCount: number;
	remediateDisabled: boolean;
	onRemediate: (option: string) => void;
}

export const TopBarActions: React.FC<TopBarActionsProps> = ({
	isLoading,
	onDownload,
	onRefresh,
	tab,
	selectedCount,
	remediateDisabled,
	onRemediate,
}) => (
	<Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
		{tab === 0 && selectedCount > 0 && (
			<Typography variant="body2" sx={{ lineHeight: '40px', mx: 1 }}>
				<b>{selectedCount}</b> selected
			</Typography>
		)}
		{tab === 0 && (
			<RemediateDropdown
				disabled={remediateDisabled}
				onSelect={onRemediate}
			/>
		)}

		<Box key="export-csv" sx={{ ml: 1, mr: 1 }}>
			<Tooltip title="Export CSV">
				<span>
					<IconButton disabled={isLoading} onClick={onDownload}>
						<Download
							sx={{
								width: '24px !important',
								height: '24px !important',
							}}
						/>
					</IconButton>
				</span>
			</Tooltip>
		</Box>
		<Box key="refresh">
			<Tooltip title="Refresh">
				<span>
					<IconButton disabled={isLoading} onClick={onRefresh}>
						<Refresh
							sx={{
								width: '24px !important',
								height: '24px !important',
							}}
						/>
					</IconButton>
				</span>
			</Tooltip>
		</Box>
	</Box>
);
